import React from "react";

/**
 * iPhone 16 mockup frame — thick visible black bezel, prominent dynamic island,
 * side buttons. Designed to wrap a bare app screenshot so it clearly reads as
 * an iPhone in the marketing site.
 */
export default function RealPhone({
  src,
  alt = "App screenshot",
  className = "",
  style,
  testid,
}) {
  return (
    <div
      className={`relative ${className}`}
      style={{
        width: 290,
        height: 615,
        borderRadius: 50,
        background: "#0a0a0a",
        boxShadow:
          "0 30px 80px -20px rgba(0,0,0,0.55), inset 0 0 0 2px rgba(255,255,255,0.08)",
        ...style,
      }}
      data-testid={testid || "real-phone"}
    >
      {/* Silver/titanium rim highlight */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          borderRadius: 50,
          boxShadow: "inset 0 0 0 1.5px rgba(255,255,255,0.22)",
        }}
      />
      {/* Glossy top sheen */}
      <div
        className="pointer-events-none absolute"
        style={{
          left: 16,
          right: 16,
          top: 4,
          height: 26,
          borderTopLeftRadius: 44,
          borderTopRightRadius: 44,
          background:
            "linear-gradient(to bottom, rgba(255,255,255,0.10), rgba(255,255,255,0))",
        }}
      />

      {/* Side buttons */}
      <span aria-hidden style={{ position: "absolute", left: -3, top: 125, width: 4, height: 32, borderTopLeftRadius: 2, borderBottomLeftRadius: 2, background: "#222" }} />
      <span aria-hidden style={{ position: "absolute", left: -3, top: 180, width: 4, height: 50, borderTopLeftRadius: 2, borderBottomLeftRadius: 2, background: "#222" }} />
      <span aria-hidden style={{ position: "absolute", left: -3, top: 245, width: 4, height: 50, borderTopLeftRadius: 2, borderBottomLeftRadius: 2, background: "#222" }} />
      <span aria-hidden style={{ position: "absolute", right: -3, top: 170, width: 4, height: 78, borderTopRightRadius: 2, borderBottomRightRadius: 2, background: "#222" }} />

      {/* Inner screen with 14px black bezel all around */}
      <div
        style={{
          position: "absolute",
          inset: 14,
          borderRadius: 38,
          overflow: "hidden",
          background: "#fff",
        }}
      >
        <img
          src={src}
          alt={alt}
          loading="lazy"
          style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top" }}
        />
      </div>

      {/* Dynamic Island (iPhone 16 pill) — sits OVER the screen, fully visible */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          top: 22,
          left: "50%",
          transform: "translateX(-50%)",
          width: 116,
          height: 34,
          borderRadius: 999,
          background: "#000",
          boxShadow: "0 2px 8px rgba(0,0,0,0.6), inset 0 0 0 1px rgba(255,255,255,0.05)",
          zIndex: 20,
        }}
      >
        {/* Camera + sensor inside the island */}
        <span style={{ position: "absolute", top: "50%", right: 12, transform: "translateY(-50%)", width: 10, height: 10, borderRadius: 999, background: "#0d1418", boxShadow: "inset 0 0 0 1.5px #1f262b" }} />
        <span style={{ position: "absolute", top: "50%", right: 32, transform: "translateY(-50%)", width: 5, height: 5, borderRadius: 999, background: "#1a1f23" }} />
      </div>

      {/* Subtle home indicator bar */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          bottom: 8,
          left: "50%",
          transform: "translateX(-50%)",
          width: 110,
          height: 5,
          borderRadius: 999,
          background: "rgba(255,255,255,0.55)",
          zIndex: 20,
        }}
      />
    </div>
  );
}
